var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"zoom-modal",on:{"click":_vm.close}},[_c('span',{staticClass:"zoom-close"},[_vm._v("×")]),_vm._v(" "),_c('img',{staticClass:"zoom-modal-content",attrs:{"src":_vm.src,"alt":"Zoom"}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6992a2c0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ZoomOnImage.vue
// module id = y2z6
// module chunks = 0